<template id="mytmp">
  <div class="clearfix">
    <div class="spinner">
      <div class="loadingtext">{{loadingtext}}</div>
      <div class="loader">Loading...</div>
    </div>
    <div class="togglebutton clearfix">
      <label class="switch">
        <input type="checkbox" class="checked" ref="togglebutton" v-on:change="togglebuttonSelect()">
        <span class="slider round"></span>
      </label>
      <span class="selcteditem">{{currenttoggle}}</span>
    </div>
    <div class="salesblock clearfix">
      <div class="highlitboxes basesales totalspent">Total Spend
        <span>
          <i></i>
        </span>
        <b>{{currencySymbol}}{{TotalSpent}}</b>
        <label>{{CompareTotalSpent}}%
          <i class="fa" :class="CompareTotalSpentArrow === 1 ? 'fa-caret-up green' : CompareTotalSpentArrow === 0 ? ' ' : 'fa-caret-down red'"></i>
        </label>
      </div>
      <div class="highlitboxes">Non Media {{kpi}}
        <span>
          <i></i>
        </span>
        <b>{{BaseSales}}</b>
      </div>
      <div class="highlitboxes medadsale togglerBoxes active">Paid Media {{Tkpi}}
        <span>
          <i></i>
        </span>
        <b class="MediaDrivenSales">{{MediaDrivenSales}}</b>
        <b class="MediaDrivenROI">{{MediaDrivenROI}}</b>
        <label>{{CompareMediaDrivenSales}}%
          <i class="fa" :class="CompareMediaDrivenSalesArrow === 1 ? 'fa-caret-up green' : CompareMediaDrivenSalesArrow === 0 ? ' ' : 'fa-caret-down red'"></i>
        </label>
      </div>
      <div class="highlitboxes ecosyssales togglerBoxes active">O/E Ecosystem {{Tkpi}}
        <span>
          <i></i>
        </span>
        <b class="EcosystemSales">{{EcosystemSales}}</b>
        <b class="EcosystemROI">{{EcosystemROI}}</b>
        <label>{{CompareEcosystemSales}}%
          <i class="fa" :class="CompareEcosystemSalesArrow === 1 ? 'fa-caret-up green' : CompareEcosystemSalesArrow === 0 ? ' ' : 'fa-caret-down red'"></i>
        </label>
      </div>
      <div class="highlitboxes tsales">Total {{kpi}}
        <span>
          <i></i>
        </span>
        <b>{{TotalSales}}</b>
        <label>{{CompareTotalSales}}%
          <i class="fa" :class="CompareTotalSalesArrow === 1 ? 'fa-caret-up green' : CompareTotalSalesArrow === 0 ? ' ' : 'fa-caret-down red'"></i>
        </label>
      </div>
    </div>

    <div class="chartarea" style="position:relative">
      <div class="tooltip2" ref="tooltip">{{ tooltipcontent }}</div>
      <div id="mynetwork">
      </div>
    </div>
    <div class="report-anualspent" style="">Annual Spend</div>
    <div class="report-max-uplift" style="">Max Uplift: {{currentnest_name}}</div>
    <div class="clearfix leftside">
      <div class="slidertop clearfix">
        <div class="slider-wrapper" :key="sliderinputval.name" v-bind="sliderinputval" v-for="(sliderinputval, index) in sliderinputval">
          <label> {{ sliderinputval.name }}</label>
          <vue-slider @callback="checkslider(sliderinputval, $event)" :ref="'slider'+index" v-model="sliderinputval.spend" v-bind="slideroptions" :max="sliderinputval.max_value" :label="sliderinputval.name">
            <div class="slider-tooltip" slot="tooltip" slot-scope="{ spend }">
              <!-- {{ sliderinputval.value }} -->
            </div>
          </vue-slider>
          <div class="slider-text">
            <input pattern="^[\d,]+$" type="text" @input="updateSlider(sliderinputval, $event)" v-bind:value="index = sliderinputval.spend.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')">
          </div>
        </div>
      </div>
      <div class="optimiseWidgetWrapper">
        <div class="inputOptimizeNamr view">
          <!-- <div class="error-msg">This is a required field.</div> -->
          <a class="verclosebutton" v-on:click="verclosebutton()">
            <i aria-hidden="true" class="fa fa-times"></i>
          </a>
          <div class="input-box">
            <input v-model="versionName" type="text" class="form-control" id="optimname" placeholder="Optimisation Version Name" required>
            <button class="reportbutton optimiseBtnGO" type="button" v-on:click="NewOptimisebtntrigger()">GO</button>
          </div>
          <i class="fa fa-caret-down optiarrow" aria-hidden="true"></i>
        </div>
        <button class="reportbutton optimiseBtn" type="button" v-on:click="NewOptimisebtnClick()">Optimise</button>

      </div>
    </div>
    <div class="clearfix excelwrapper reportpageexcelwrapper">
      <HotTable :root="root" :settings="hotSettings" observeChanges="true" class='handsontable handsontableReport' onAfterChangesObserved="true"></HotTable>
    </div>
    <div class="reportbuttonwrapper clearfix">
      <button class="reportbutton" type="button" :disabled="updateBtnDisable" v-on:click="UpdatebtnClick('update')">Update</button>
      <button class="reportbutton" v-on:click="savebuttonclick" type="button">Save</button>
      <button class="reportbutton" type="button" v-on:click="cancelClick" :disabled="disabled">Cancel</button>
      <button class="reportbutton resetreportBtn" type="button" v-on:click="resetbtnClick()">Reset</button>

    </div>
    <div class="helpertable">
      <table>
        <tr>
          <td>Model Name</td>
          <td>{{modelname}}</td>
        </tr>
        <tr>
          <td>Market</td>
          <td>{{country }}</td>
        </tr>
        <tr>
          <td>Category</td>
          <td>{{category}}</td>
        </tr>
        <tr>
          <td colspan="2" class="heading">
            Version
          </td>
        </tr>
        <tr>
          <td colspan="2">
            <select ref="versionsCombo" class="form-control" v-model="modelVesrionSelect" id="modelVesrionSelect" @change="modelVesrionSelectChanged()">
              <!-- <option v-if="versions.length !== 0" selected v-bind:value="versions[0]"  v-bind:key="versions[0]">{{ versions[0] }}</option> -->
              <option v-bind:disabled="false" v-if="versions.version_status === 'completed' ? 'disable' : '' " v-bind:selected="index === 0 ? true : false" v-for="(versions, index) in versions" v-bind:value="index" v-bind:key="versions.version_id">{{ versions.text }}</option>
            </select>
          </td>
        </tr>
      </table>
    </div>
    <div>
    </div>
    <simplert :useRadius="true" :useIcon="true" ref="simplert">
    </simplert>
  </div>
</template>
<script>

import vis from 'vis'
// import Vue from 'Vue'
import vueSlider from 'vue-slider-component'
import HotTable from 'vue-handsontable-official'
import Simplert from 'vue2-simplert'
import Jquery from 'jquery'
var $ = Jquery
// var output_chartData = require('../../../static/json/output_chart.json')
export default {
  name: 'ovs-network',
  components: { vueSlider, HotTable, Simplert },
  data () {
    return {
      enableCompare: false,
      currencySymbol: '',
      modelVesrionSelect: 0,
      versionName: '',
      versions: [],
      NewOptimiseClick: false,
      Tkpi: 'Sale',
      currenttoggle: this.kpi,
      sliderLength: 0,
      excelHeight: 0,
      loadingtext: '',
      currentnest_name: '',
      updateBtnDisable: true,
      validationArray: [],
      cellChanges: [],
      root: 'test-hot',
      reportj: [],
      dupreportj: [],
      currentNest: [],
      observeChanges: true,
      category: '',
      country: '',
      modelname: '',
      datachangeobj: [],
      kpi: 'Sales',
      hotSettings: {
        afterChange: function (changes, source) {
          if (this.isListening()) {
            let maup = this.getActiveEditor()
            if (maup.originalValue === 0) {
              return false
            }
            this.rootElement.__vue__.$parent.dupreportj = this.rootElement.__vue__.$parent.reportj
            this.rootElement.__vue__.$parent.updateBtnDisable = false
            var datachangeobj = this.getData()
            // console.log(datachangeobj)
            if (this.rootElement.__vue__.$parent.datachangeobj.length === 0) {
              this.rootElement.__vue__.$parent.currentNest = []
              let nestNname = this.getColHeader()[1]
              nestNname = nestNname.split(' %')[0]
              nestNname = String(nestNname)
              this.rootElement.__vue__.$parent.currentnest_name = nestNname
              nestNname = nestNname.replace(/\s/gi, '_')
              let nestobj = {
                'nest_name': nestNname,
                'channel': datachangeobj
              }
              this.rootElement.__vue__.$parent.dupreportj.asymptote_values[nestNname].channel
              this.rootElement.__vue__.$parent.updateBtnDisable = false
              this.rootElement.__vue__.$parent.datachangeobj.push(nestobj)
              this.rootElement.__vue__.$parent.currentNest.push(nestobj)
            }
          }
          // console.log()
          this.rootElement.__vue__.$parent.datachangeobj = []
          if (!changes) {
            return
          }
          if (source === 'edit') {
            let that = this
            let colIndex = 1
            let getData = this.getData()
            Object.keys(getData).forEach(function (rowIndex) {
              var element = that.getCell(rowIndex, colIndex)
              if (getData[rowIndex][1] === '') {
                setTimeout(function () { element.className = 'emptyCells' }, 0)
              }
            })
          }
        },
        autoWrapRow: true,
        width: 500,
        height: 200,
        maxRows: 10,
        maxColsNumber: 2,
        colWidths: 230,
        className: 'esheetclass',
        tableClassName: 'exceltablestyle',
        colHeaders: [' ', ''], // this.reportj.asymptote_values.Sales.nest_name
        data: [], // this.reportj.asymptote_values.Sales.channel,
        columns: [
          {
            data: 'name',
            readOnly: true
          },
          {
            data: 'value'
          }
        ],
        disableVisualSelection: true
      },
      gridcolumns: [
        {
          title: 'Id',
          name: 'id',
          editable: false
        },
        {
          title: 'Firstname',
          name: 'firstname',
          editable: true
        },
        {
          title: 'Lastname',
          name: 'lastname',
          editable: true
        },
        {
          title: 'Email',
          name: 'email',
          editable: true
        }
      ],
      gridoptions: {
        showSearchFilter: false,
        requests: {
          allUrl: 'http://api.dev/api/users'
        }
      },
      sliderinputval: [],
      BaseSales: [],
      TotalSpent: 0,
      TotalSpentarr: [],
      MediaDrivenSales: [],
      EcosystemSales: [],
      CompareTotalSpent: 0,
      CompareEcosystemSales: [],
      CompareTotalSales: [],
      CompareMediaDrivenSales: [],
      CompareTotalSpentArrow: 0,
      CompareEcosystemSalesArrow: 0,
      CompareTotalSalesArrow: 0,
      CompareMediaDrivenSalesArrow: 0,
      EcosystemROI: 0,
      MediaDrivenROI: 0,
      TotalSales: [],
      showtooltip: false,
      tooltipcontent: '',
      clickcheck: [0],
      paidmediaCheck: [],
      slideroptions: {
        eventType: 'auto',
        direction: 'horizontal',
        height: 8,
        width: '50%',
        dotSize: 16,
        dotHeight: null,
        dotWidth: null,
        min: 0,
        max: 100,
        sliderStyle: [{
          'backgroundColor': '#ce785b',
          'boxShadow': 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)'
        }],
        interval: 1,
        show: true,
        speed: 0.5,
        disabled: false,
        piecewise: false,
        autoResize: true,
        'piecewise-Style': {
          'backgroundColor': '#ce785b',
          'visibility': 'visible',
          'width': '12px',
          'height': '12px'
        },
        piecewiseActiveStyle: {
          'backgroundColor': '#ce785b'
        },
        labelActiveStyle: {
          'backgroundColor': '#ce785b'
        },
        tooltipStyle: {
          'backgroundColor': '#000',
          'borderColor': '#f05b72'
        },
        piecewiseLabel: false,
        tooltip: 'always',
        tooltipDir: 'top',
        reverse: false,
        data: null,
        clickable: true,
        realTime: false,
        lazy: false,
        formatter: null,
        bgStyle: {
          'backgroundColor': '#d8d8d8'
        },
        processStyle: {
          'backgroundColor': '#ce785b'
        }
      },
      network: null,
      nodes: [],
      addnodes: [],
      edges: [],
      addedges: [],
      options: {
        physics: {
          'enabled': false,
          'forceAtlas2Based': {
            'gravitationalConstant': -133,
            'centralGravity': 0.15,
            'springLength': 40,
            'springConstant': 0.345,
            'damping': 1,
            'avoidOverlap': 1
          },
          'maxVelocity': 57,
          'minVelocity': 0.01,
          'solver': 'forceAtlas2Based',
          'timestep': 0.01,
          stabilization: {
            enabled: true,
            iterations: 100,
            updateInterval: 100,
            onlyDynamicEdges: true,
            fit: true
          }
        },
        layout: {
          randomSeed: 1,
          improvedLayout: true,
          hierarchical: {
            enabled: true,
            levelSeparation: 65,
            nodeSpacing: 120,
            treeSpacing: 150,
            blockShifting: true,
            edgeMinimization: true,
            parentCentralization: true,
            direction: 'UD',        // UD, DU, LR, RL
            sortMethod: 'hubsize'   // hubsize, directed
          }
        },
        nodes: {
          chosen: true,
          borderWidthSelected: 8,
          shape: 'dot',
          size: 30,
          scaling: {
            min: 10,
            max: 30,
            label: {
              enabled: false,
              min: 14,
              max: 30,
              maxVisible: 30,
              drawThreshold: 5
            },
            customScalingFunction: function (min, max, total, value) {
              if (max === min) {
                return 0.5
              } else {
                let scale = 1 / (max - min)
                return Math.max(0, (value - min) * scale)
              }
            }
          }
        },
        edges: {
          'smooth': {
            'type': 'curvedCW',
            'roundness': 0.45
          },
          arrowStrikethrough: true,
          chosen: true,
          color: {
            inherit: 'from',
            opacity: 1.0
          },
          scaling: {
            min: 1,
            max: 5,
            label: {
              enabled: true,
              min: 14,
              max: 30,
              maxVisible: 30,
              drawThreshold: 5
            },
            customScalingFunction: function (min, max, total, value) {
              if (max === min) {
                return 0.5
              } else {
                var scale = 1 / (max - min)
                return Math.max(0, (value - min) * scale)
              }
            }
          },
          selectionWidth: 1,
          selfReferenceSize: 20
        },
        interaction: {
          dragNodes: true,
          dragView: false,
          hideEdgesOnDrag: false,
          hideNodesOnDrag: false,
          hover: true,
          hoverConnectedEdges: true,
          keyboard: {
            enabled: false,
            speed: { x: 10, y: 10, zoom: 0.02 },
            bindToWindow: true
          },
          multiselect: true,
          navigationButtons: true,
          selectable: true,
          selectConnectedEdges: true,
          tooltipDelay: 0,
          zoomView: false
        },
        manipulation: {
          enabled: true,
          addNode: true,
          addEdge: true
        },
        configure: {
          enabled: false,
          filter: 'nodes,edges'
        }
      },
      container: '',
      disabled: false
    }
  },
  watch: {
    excelHeight: function (params) {
      let lenghtinslider = this.sliderLength + 1
      let slidertopheight = ((lenghtinslider * 46) + 40)
      $('.excelwrapper').height(slidertopheight)
      $('.handsontableReport').height(slidertopheight)

      // watch slider input change
    }
  },
  computed: {
    // computed block
  },
  methods: {
    modelVesrionSelectChanged () {
      var self = this
      var jobId = window.localStorage.getItem('JobId')
      var versionid = self.versions[self.modelVesrionSelect].version_id
      jobId = jobId.replace('job-id=', '')
      Jquery.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/getecosystemoutput',
        async: true,
        contentType: 'application/json',
        data: { 'job-id': jobId, 'user-id': window.localStorage.getItem('user'), 'nest': 'all', 'version-id': versionid },
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          $('.spinner').show()
          self.loadingtext = 'applying new values...'
          setTimeout(() => {
            self.loadingtext = 'adjusting calculations...'
          }, 200)
          setTimeout(() => {
            self.loadingtext = 'almost done!'
          }, 300)
          // $('.spinner').css({ top: '14%' })
        },
        complete: function () {
          console.log(self)
          // self.modelVesrionSelect = 0
          $('.spinner').hide()
          // $('#job select option[value=0]').attr('selected', 'true')
        },
        success: function (data) {
          data = data['output']
          // data = JSON.parse(data)
          // var mydata = data[0]['name']
          try {
            self.reportj = data
            self.sliderinputval = self.reportj.AnnualSpend
            self.BaseSales = self.reportj.BaseSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
            // self.TotalSpent = 0
            self.MediaDrivenSales = self.reportj.MediaDrivenSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
            self.EcosystemSales = self.reportj.EcosystemSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
            self.TotalSales = self.reportj.TotalSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
            self.EcosystemROI = self.reportj.EcosystemROI
            self.MediaDrivenROI = self.reportj.MediaDrivenROI
            var result = Object.keys(self.reportj.AnnualSpend).map(function (key) {
              return [self.reportj.AnnualSpend[key]]
            })
            if (self.reportj.compare !== undefined) {
              self.enableCompare = true
            } else if (self.reportj.compare === undefined) {
              self.enableCompare = false
            }
            if (self.enableCompare === true) {
              // do something
              self.CompareTotalSpent = self.reportj.compare.AnnualSpend.per
              self.CompareEcosystemSales = self.reportj.compare.EcosystemSales.per
              self.CompareTotalSales = self.reportj.compare.TotalSales.per
              self.CompareMediaDrivenSales = self.reportj.compare.MediaDrivenSales.per
              self.CompareTotalSpentArrow = self.reportj.compare.AnnualSpend.effect
              self.CompareEcosystemSalesArrow = self.reportj.compare.EcosystemSales.effect
              self.CompareTotalSalesArrow = self.reportj.compare.TotalSales.effect
              self.CompareMediaDrivenSalesArrow = self.reportj.compare.MediaDrivenSales.effect
              $('.highlitboxes span').css({ 'top': '-17px' })
              $('.highlitboxes label').css({ 'display': 'block' })
            } else if (self.enableCompare === false) {
              $('.highlitboxes span').css({ 'top': '-25px' })
              $('.highlitboxes label').css({ 'display': 'none' })
            }
            self.clickcheck = []
            self.nodes = []
            self.edges = []
            var nodes = new vis.DataSet(self.nodes)
            var edges = new vis.DataSet(self.edges)
            self.reportj.nodes.forEach(function (value, index) {
              if (value.id <= 99 && value.id > 0) {
                self.reportj.edges.forEach(function (evalue, eindex) {
                  if (value.id === evalue.from) {
                    if (evalue.from < 99 && evalue.to === 0) {
                      self.nodes.push(value)
                      nodes.add(value)
                      // window.network.body.data.nodes._updateItem(value)
                    }
                  }
                })
              } else if (value.id === 0) {
                self.nodes.push(value)
                nodes.add(value)
              } else {
                self.addnodes.push(value)
              }
            })
            self.reportj.edges.forEach(function (value, index) {
              if (value.to === 0) {
                self.edges.push(value)
                edges.add(value)
              } else {
                self.addedges.push(value)
              }
            })
            self.container = document.getElementById('mynetwork')
            var newdata = {
              nodes: nodes,
              edges: edges
            }
            self.clickcheck = []
            window.network.setData(newdata)
            window.network = new vis.Network(self.container, newdata, self.options)
            window.network.on('doubleClick', function (params) {
              params.event = '[original event]'
              if (this.getNodeAt(params.pointer.DOM) === undefined) {
                return false
              }

              var nodesDataset = new vis.DataSet(self.nodes)
              var currentNodeLabel = nodesDataset.get(params.nodes)[0].id
              self.updateHotSetting(params, nodesDataset)
              if (currentNodeLabel === 0 || this.getNodeAt(params.pointer.DOM) === undefined) {
                return false
              }
              self.handleNetworkClickEvent(edges, nodes, currentNodeLabel)
            })
            window.network.on('hoverEdge', function (params, event) {
              params.event = '[original event]'
              var currentEdgeValue = this.body.data.edges.get(params.edge).title
              self.handleHoverEdgeEvent(params, currentEdgeValue)
            })
            window.network.on('blurEdge', function (params, event) {
              params.event = '[original event]'
              self.handleNodeEdgeBlurEvent()
            })
            var changeCursor = function (newCursorStyle) {
              var networkCanvas = document.getElementById('mynetwork').getElementsByTagName('canvas')[0]
              networkCanvas.style.cursor = newCursorStyle
            }
            window.network.on('hoverNode', function (params, event) {
              params.event = '[original event]'
              changeCursor('pointer')
              var currentEdgeValue = this.body.data.nodes.get(params.node).value
              var currentnodename = this.body.data.nodes.get(params.node).label
              self.handleHoverNodeEvent(params, currentEdgeValue, currentnodename)
            })
            window.network.on('blurNode', function (params, event) {
              params.event = '[original event]'
              self.handleNodeEdgeBlurEvent()
            })
            self.TotalSpentarr = result
            self.hotSettings.colHeaders = ['', self.reportj.asymptote_values[self.kpi].nest_name + ' %']
            self.currentNest = self.reportj.asymptote_values[self.kpi]
            self.currentnest_name = self.reportj.asymptote_values[self.kpi].nest_name
            self.hotSettings.data = self.reportj.asymptote_values[self.kpi].channel
            self.calculatetotalspent(result)
            self.country = self.reportj.country
            self.modelname = self.reportj.name
            self.category = self.reportj.category
          } catch (err) {
            console.log(err)
            $('.spinner').hide()
            self.errorPopup()
          }
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          // console.log(data)
          console.log(error)
          $('.spinner').hide()
          self.errorPopup()
        }
      })
    },
    NewOptimisebtnClick () {
      this.NewOptimiseClick = true
      $('.inputOptimizeNamr').removeClass('view')
    },
    verclosebutton () {
      this.NewOptimiseClick = false
      $('.inputOptimizeNamr').addClass('view')
    },
    NewOptimisebtntrigger () {
      var self = this
      var postdata = []
      var dupreportj = self.dupreportj
      var jobId = window.localStorage.getItem('JobId')
      jobId = jobId.replace('job-id=', '')
      let versionName = self.versionName
      if (versionName.length === 0) {
        $('.error-msg').show()
        $('#optimname').addClass('error')
        return
      }
      if (dupreportj.length === 0) {
        // for optimise button data
        dupreportj = self.reportj
      }
      var newstringer = {
        'job-id': jobId,
        'user-id': window.localStorage.getItem('user'),
        'AnnualSpend': dupreportj.AnnualSpend,
        'asymptote_values': dupreportj.asymptote_values,
        'version-name': versionName
      }
      newstringer = JSON.stringify(newstringer)
      postdata.push(
        {
          'data': newstringer
        }
      )
      var mydatato = postdata[0]
      mydatato = $.param(mydatato)
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/OptimiseEcosystemOutput',
        data: mydatato,
        async: true,
        contentType: 'application/json',
        headers: {
          // 'Access-Control-Allow-Origin': '*',
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          $('.spinner').show()
          // $('.spinner').css({ top: '14%' })
        },
        complete: function () {
          $('.spinner').hide()
          self.OptimisebtnClick()
          self.verclosebutton()
          self.versionName = ''
          self.optimiseDatapopup()
          // self.cexcelHeight()
          // $('#job select option[value=0]').attr('selected', 'true')
        },
        success: function (data) {
          // data = data['output']

          // data = JSON.parse(data)
          // $('.spinner').hide()

          // var mydata = data[0]['name']
          // self.displaypopup()
        },
        error: function (data, error) {
          // console.log(data)
          console.log(error)
          $('.spinner').hide()
          self.errorPopup()
        }
      })
    },
    togglebuttonSelect () {
      if ($('.togglebutton input').hasClass('checked') === false) {
        $('.togglebutton input').addClass('checked')
        $('.togglerBoxes').addClass('active')
        this.currenttoggle = this.kpi
        this.Tkpi = this.kpi
      } else if ($('.togglebutton input').hasClass('checked')) {
        $('.togglebutton input').removeClass('checked')
        $('.togglerBoxes').removeClass('active')
        this.currenttoggle = 'ROI'
        this.Tkpi = 'ROI'
        this.EcosystemROI = this.reportj.EcosystemROI // .toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        this.MediaDrivenROI = this.reportj.MediaDrivenROI // .toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      }
    },
    cexcelHeight () {
      this.excelHeight = this.excelheight + 1
    },
    resetbtnClick () {
      let err = {
        title: 'Coming Soon',
        message: ' ',
        type: 'success',
        customClass: 'success',
        customCloseBtnClass: 'reportbutton',
        onClose: this.resetClose
      }
      this.$refs.simplert.openSimplert(err)
    },
    resetClose () {
      //
    },
    OptimisebtnClick () {
      console.log(this.slideroptions)
      // this.UpdatebtnClick('optimise')
      this.slideroptions.sliderStyle[0].backgroundColor = '#444'
      this.slideroptions.bgStyle.backgroundColor = '#444'
      this.slideroptions.piecewiseActiveStyle.backgroundColor = '#444'
      this.slideroptions.processStyle.backgroundColor = '#444'
      this.slideroptions.tooltipStyle.backgroundColor = '#444'
      this.slideroptions.labelActiveStyle.backgroundColor = '#444'
      $('.vue-slider-dot').addClass('graydot')
    },
    optimiseClose () {
      //
    },
    cancelClick () {
      this.$router.push('/')
    },
    errorPopup () {
      let err = {
        title: 'It looks like, you have hit an error',
        message: 'Please raise a ticket in yammer group',
        type: 'error',
        customClass: 'error'
      }
      this.$refs.simplert.openSimplert(err)
    },
    optimiseDatapopup () {
      let err = {
        title: 'Optimisation will take sometime, check back in few mins',
        message: ' ',
        type: 'success',
        customClass: 'success',
        customCloseBtnClass: 'reportbutton'
      }
      this.$refs.simplert.openSimplert(err)
    },
    saveDatapopup () {
      let err = {
        title: 'Data Saved',
        message: ' ',
        type: 'success',
        customClass: 'success',
        customCloseBtnClass: 'reportbutton'
      }
      this.$refs.simplert.openSimplert(err)
    },
    savebuttonclick () {
      // let save = true
      this.UpdatebtnClick('save')
    },
    updateSlider: function (val, event) {
      let newstr = String(val.name)
      newstr = newstr.replace(/\s/gi, '_')
      let currentNum = event.currentTarget.value
      currentNum = currentNum.replace(/,/gi, '')
      this.$refs['slider' + newstr][0].setValue(currentNum)
    },
    checkslider: function (val, event) {
      let newstr = String(val.name)
      newstr = newstr.replace(/\s/gi, '_')
      this.dupreportj = this.reportj
      this.reportj.AnnualSpend[newstr].spend = val.spend
      this.dupreportj.AnnualSpend[newstr].spend = val.spend
      this.updateBtnDisable = false
    },
    handleNetworkClickEvent (edges, nodes, currentNodeLabel) {
      var self = this
      var edgearray = self.reportj.edges
      var nodearray = self.reportj.nodes
      // var newfilterarray = []
      var idObject = {}
      Object.keys(edges._data).forEach(function (key1) {
        let outerTo = edges._data[key1].to
        let outerFrom = edges._data[key1].from
        Object.keys(edges._data).forEach(function (key2) {
          let innerTo = edges._data[key2].to
          let innerFrom = edges._data[key2].from
          if (innerFrom !== outerFrom && innerTo === outerTo) {
            idObject[edges._data[key2].id] = edges._data[key2]
          }
        })
      })
      let getExistingEdgesArray = []
      if (self.clickcheck.length > 0 && self.clickcheck.includes(currentNodeLabel)) {
        //
        Object.keys(edges._data).forEach(function (index) {
          // console.log((edges._data[index]))
          if ((edges._data[index].to > 99) && nodearray.includes(edges._data[index].to)) {
            self.paidmediaCheck.push(edges._data[index])
          }
          if ((edges._data[index].to === currentNodeLabel)) {
            getExistingEdgesArray.push(edges._data[index])
            // console.log((edges._data[index]))
          }
        })
        // let isNodesEdgesDelete = false
        var deleteNodesOnClick = getExistingEdgesArray.map(function (e, i) {
          // console.log(e)
          let getId = e.id
          // console.log(getId)
          if ((e.from !== 0 || e.to !== 0) && (e.to === currentNodeLabel)) {
            edges.remove(e.id)
          }
          if (idObject[getId]) {
            let cnodeChild = []
            let othernodesChild = []
            let diffNode = []
            edgearray.forEach(function (edgekey) {
              if (edgekey.to === currentNodeLabel) {
                cnodeChild.push(edgekey.from)
                // console.log('child for current node is ' + edgekey.from)
              }
            })
            // Get the child of all other active expand nodes
            edgearray.forEach(function (edgekey) {
              if (self.clickcheck.includes(edgekey.to) && edgekey.to !== 0) {
                if (((edgekey.to !== currentNodeLabel) && (edgekey.from > 99))) {
                  // console.log('checking parent node ' + edgekey.to)
                  // console.log('Is included in clickcheck? ' + self.clickcheck.includes(edgekey.to))
                  othernodesChild.push(edgekey.from)
                  // console.log('child for othernodesChild is ' + edgekey.from)
                }
              }
            })
            // Get the difference from above
            diffNode = cnodeChild.filter(function (x) {
              return othernodesChild.indexOf(x) < 0
            })
            // Get the child of the active collapse request node
            diffNode.forEach(function (remkey) {
              nodes.remove(remkey)
              // console.log('removing ' + remkey.from)
            })
          }
          // isNodesEdgesDelete = true
          return true
        })
        let nodelabelindex = self.clickcheck.indexOf(currentNodeLabel)
        self.clickcheck.splice(nodelabelindex, 1)
        if (deleteNodesOnClick.includes(true)) {
          return false
        }
      }
      // add nodes and edges
      edgearray.forEach(function (val, index) {
        if (val.to === currentNodeLabel) {
          let valin = val.from
          // newfilterarray.push(val)
          nodearray.find(function (element) {
            if (element.id === valin) {
              // console.log(nodes)
              if (nodes._getItem(element.id) === null) {
                // console.log('add node= ' + val)
                nodes.add(element)
                if (element.id > 99) {
                  self.paidmediaCheck.push(element.id)
                }
              }
            }
          })
          window.network.stabilize()
          // check duplicate edges if alredy present don't add new
          if (edges._getItem(val.id) === null) {
            // console.log('add edged= ' + val)
            edges.add(val)
          }
          self.edges.push(val)
          // edges.add(val)
          window.network.redraw()
          return
        }
      })
      if (self.clickcheck.includes(currentNodeLabel) === false) {
        self.clickcheck.push(currentNodeLabel)
      }
    },
    handleHoverEdgeEvent (params, currentEdgeValue) {
      this.$refs.tooltip.style.x = params.pointer.DOM.x
      this.$refs.tooltip.style.y = params.pointer.DOM.y
      $('.tooltip2').css({
        'top': params.pointer.DOM.y,
        'left': params.pointer.DOM.x
      })
      $('.tooltip2').text(currentEdgeValue)
      $('.tooltip2').css({ 'opacity': '1' })
    },
    handleHoverNodeEvent (params, currentEdgeValue, currentnodename) {
      this.$refs.tooltip.style.x = params.pointer.DOM.x + 15
      this.$refs.tooltip.style.y = params.pointer.DOM.y + 15
      $('.tooltip2').css({
        'top': params.pointer.DOM.y + 15,
        'left': params.pointer.DOM.x + 15
      })
      $('.tooltip2').text(currentnodename + ' : ' + currentEdgeValue)
      this.reportj.nodes.find(function (element) {
        if (element.label === currentnodename) {
          $('.tooltip2').text(currentnodename + ' : ' + Math.floor(element.value))
        }
      })
      $('.tooltip2').css({ 'opacity': '1' })
      // network.emit('click')
    },
    handleNodeEdgeBlurEvent () {
      $('.tooltip2').css({ 'opacity': '0' })
      return
    },
    updateHotSetting (params, nodesDataset) {
      let self = this
      var selectednode = nodesDataset.get(params.nodes)[0].label
      var newstr = String(selectednode)
      newstr = newstr.replace(/\s/gi, '_')
      self.hotSettings.colHeaders = ['', self.reportj.asymptote_values[newstr].nest_name + ' %']
      self.hotSettings.data = self.reportj.asymptote_values[newstr].channel
      self.currentNest = self.reportj.asymptote_values[newstr]
      self.currentnest_name = self.reportj.asymptote_values[newstr].nest_name
    },
    onUpdatechangeSlidertheame () {
      console.log(this.slideroptions)
      // this.UpdatebtnClick('optimise')
      this.slideroptions.sliderStyle[0].backgroundColor = '#ce785b'
      this.slideroptions.bgStyle.backgroundColor = '#ce785b'
      this.slideroptions.piecewiseActiveStyle.backgroundColor = '#ce785b'
      this.slideroptions.processStyle.backgroundColor = '#ce785b'
      this.slideroptions.tooltipStyle.backgroundColor = '#ce785b'
      this.slideroptions.labelActiveStyle.backgroundColor = '#ce785b'
      $('.vue-slider-dot').removeClass('graydot')
    },
    UpdatebtnClick (saveparm) {
      let parm = saveparm
      var self = this
      let saveParm = false
      var postdata = []
      let mode = ''
      var dupreportj = self.dupreportj
      var jobId = window.localStorage.getItem('JobId')
      jobId = jobId.replace('job-id=', '')
      if (parm === 'save') {
        saveParm = true
        mode = 'save'
        this.onUpdatechangeSlidertheame()
      } else if (parm === 'optimise') {
        saveParm = false
        mode = 'optimise'
      } else if (parm === 'update') {
        saveParm = false
        mode = 'update'
        self.enableCompare = true
        this.onUpdatechangeSlidertheame()
      }
      if (dupreportj.length === 0) {
        // for optimise button data
        dupreportj = self.reportj
      }
      var newstringer = {
        'job-id': jobId,
        'user-id': window.localStorage.getItem('user'),
        'AnnualSpend': dupreportj.AnnualSpend,
        'asymptote_values': dupreportj.asymptote_values,
        'save-output': saveParm,
        'mode': mode,
        'version-id': self.versions[self.$refs.versionsCombo.value].version_id
      }
      newstringer = JSON.stringify(newstringer)
      postdata.push(
        {
          'data': newstringer
        }
      )
      var mydatato = postdata[0]
      mydatato = $.param(mydatato)
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/UpdateEcosystemOutput',
        data: mydatato,
        async: true,
        contentType: 'application/json',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          $('.spinner').show()
          if (mode === 'update') {
            self.loadingtext = 'applying new values...'
            setTimeout(() => {
              self.loadingtext = 'adjusting calculations...'
            }, 3000)
            setTimeout(() => {
              self.loadingtext = 'almost done!'
            }, 6000)
          } else if (mode === 'save') {
            self.loadingtext = 'adjusting input template...'
            setTimeout(() => {
              self.loadingtext = 'saving values...'
            }, 3000)
            setTimeout(() => {
              self.loadingtext = 'almost done!'
            }, 4500)
          } else if (mode === 'optimise') {
            self.loadingtext = 'calculating optimal spend...'
            setTimeout(() => {
              self.loadingtext = 'adjusting calculations...'
            }, 3000)
            setTimeout(() => {
              self.loadingtext = 'almost done!'
            }, 4500)
          }
          // $('.spinner').css({ top: '14%' })
        },
        complete: function () {
          $('.spinner').hide()
          if (saveParm === true) {
            self.saveDatapopup()
          }
          self.cexcelHeight()
          // $('#job select option[value=0]').attr('selected', 'true')
        },
        success: function (data) {
          data = data['output']
          try {
            data = JSON.parse(data)
            // var mydata = data[0]['name']
            self.reportj = data
            self.sliderinputval = self.reportj.AnnualSpend
            self.BaseSales = self.reportj.BaseSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
            // self.TotalSpent = 0
            self.MediaDrivenSales = self.reportj.MediaDrivenSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
            self.EcosystemSales = self.reportj.EcosystemSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
            self.TotalSales = self.reportj.TotalSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
            self.EcosystemROI = self.reportj.EcosystemROI
            self.MediaDrivenROI = self.reportj.MediaDrivenROI
            // self.CompareTotalSales = self.reportj.
            var result = Object.keys(self.reportj.AnnualSpend).map(function (key) {
              return [self.reportj.AnnualSpend[key]]
            })
            if (self.enableCompare === true) {
              // do something
              self.CompareTotalSpent = self.reportj.compare.AnnualSpend.per
              self.CompareEcosystemSales = self.reportj.compare.EcosystemSales.per
              self.CompareTotalSales = self.reportj.compare.TotalSales.per
              self.CompareMediaDrivenSales = self.reportj.compare.MediaDrivenSales.per
              self.CompareTotalSpentArrow = self.reportj.compare.AnnualSpend.effect
              self.CompareEcosystemSalesArrow = self.reportj.compare.EcosystemSales.effect
              self.CompareTotalSalesArrow = self.reportj.compare.TotalSales.effect
              self.CompareMediaDrivenSalesArrow = self.reportj.compare.MediaDrivenSales.effect
              $('.highlitboxes span').css({ 'top': '-17px' })
              $('.highlitboxes label').css({ 'display': 'block' })
            }
            self.clickcheck = []
            self.nodes = []
            self.edges = []
            var nodes = new vis.DataSet(self.nodes)
            var edges = new vis.DataSet(self.edges)
            self.reportj.nodes.forEach(function (value, index) {
              if (value.id <= 99 && value.id > 0) {
                self.reportj.edges.forEach(function (evalue, eindex) {
                  if (value.id === evalue.from) {
                    if (evalue.from < 99 && evalue.to === 0) {
                      self.nodes.push(value)
                      nodes.add(value)
                      // window.network.body.data.nodes._updateItem(value)
                    }
                  }
                })
              } else if (value.id === 0) {
                self.nodes.push(value)
                nodes.add(value)
              } else {
                self.addnodes.push(value)
              }
            })
            self.reportj.edges.forEach(function (value, index) {
              if (value.to === 0) {
                self.edges.push(value)
                edges.add(value)
              } else {
                self.addedges.push(value)
              }
            })
            self.container = document.getElementById('mynetwork')
            var newdata = {
              nodes: nodes,
              edges: edges
            }
            self.clickcheck = []
            window.network.setData(newdata)
            window.network = new vis.Network(self.container, newdata, self.options)
            window.network.on('doubleClick', function (params) {
              params.event = '[original event]'
              if (this.getNodeAt(params.pointer.DOM) === undefined) {
                return false
              }

              var nodesDataset = new vis.DataSet(self.nodes)
              var currentNodeLabel = nodesDataset.get(params.nodes)[0].id
              self.updateHotSetting(params, nodesDataset)
              if (currentNodeLabel === 0 || this.getNodeAt(params.pointer.DOM) === undefined) {
                return false
              }
              self.handleNetworkClickEvent(edges, nodes, currentNodeLabel)
            })
            window.network.on('hoverEdge', function (params, event) {
              params.event = '[original event]'
              var currentEdgeValue = this.body.data.edges.get(params.edge).title
              self.handleHoverEdgeEvent(params, currentEdgeValue)
            })
            window.network.on('blurEdge', function (params, event) {
              params.event = '[original event]'
              self.handleNodeEdgeBlurEvent()
            })
            var changeCursor = function (newCursorStyle) {
              var networkCanvas = document.getElementById('mynetwork').getElementsByTagName('canvas')[0]
              networkCanvas.style.cursor = newCursorStyle
            }
            window.network.on('hoverNode', function (params, event) {
              params.event = '[original event]'
              changeCursor('pointer')
              var currentEdgeValue = this.body.data.nodes.get(params.node).value
              var currentnodename = this.body.data.nodes.get(params.node).label
              self.handleHoverNodeEvent(params, currentEdgeValue, currentnodename)
            })
            window.network.on('blurNode', function (params, event) {
              params.event = '[original event]'
              self.handleNodeEdgeBlurEvent()
            })
            self.TotalSpentarr = result
            self.hotSettings.colHeaders = ['', self.reportj.asymptote_values[self.kpi].nest_name + ' %']
            self.currentNest = self.reportj.asymptote_values[self.kpi]
            self.currentnest_name = self.reportj.asymptote_values[self.kpi].nest_name
            self.hotSettings.data = self.reportj.asymptote_values[self.kpi].channel
            self.calculatetotalspent(result)
            self.country = self.reportj.country
            self.modelname = self.reportj.name
            self.category = self.reportj.category
          } catch (err) {
            console.log(err)
            $('.spinner').hide()
            self.errorPopup()
          }
          return data
          // self.displaypopup()
        },
        error: function (data, error) {
          // console.log(data)
          console.log(error)
          $('.spinner').hide()
          self.errorPopup()
        }
      })
    },
    calculatetotalspent (anualspentarray) {
      var self = this
      var totspent = 0
      Array.from(anualspentarray).forEach(function (val, index) {
        totspent = totspent + val[0].spend
      })
      // Number.parseInt(totspent)
      totspent = Math.trunc(totspent)
      totspent = totspent.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
      self.TotalSpent = totspent
      return totspent
      // TotalSpent
    }
  },
  mounted () {
    var self = this
    var jobId = window.localStorage.getItem('JobId')
    var versionid = window.localStorage.getItem('JobVersion')
    jobId = jobId.replace('job-id=', '')
    Jquery.ajax({
      type: 'POST',
      url: window.localStorage.getItem('ApiURL') + '/getecosystemoutput',
      async: true,
      contentType: 'application/json',
      data: { 'job-id': jobId, 'user-id': window.localStorage.getItem('user'), 'nest': 'all', 'version-id': versionid },
      headers: {
        'x-api-key': window.localStorage.getItem('XpiKey')
      },
      beforeSend: function () {
        $('.spinner').show()
        self.loadingtext = 'applying new values...'
        setTimeout(() => {
          self.loadingtext = 'adjusting calculations...'
        }, 200)
        setTimeout(() => {
          self.loadingtext = 'almost done!'
        }, 300)
        // $('.spinner').css({ top: '14%' })
      },
      complete: function () {
        console.log(self)
        // self.modelVesrionSelect = 0
        $('.spinner').hide()
        // $('#job select option[value=0]').attr('selected', 'true')
      },
      success: function (data) {
        // console.log(data)
        data = data['output']
        // data = self.output_chart
        try {
          self.reportj = data
          self.sliderinputval = self.reportj.AnnualSpend
          self.BaseSales = self.reportj.BaseSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          self.country = self.reportj.country
          self.modelname = self.reportj.name
          self.category = self.reportj.category
          // self.TotalSpent = 0
          self.MediaDrivenSales = self.reportj.MediaDrivenSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          self.EcosystemSales = self.reportj.EcosystemSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          self.TotalSales = self.reportj.TotalSales.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          self.EcosystemROI = self.reportj.EcosystemROI  // .toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          self.MediaDrivenROI = self.reportj.MediaDrivenROI // .toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          self.kpi = self.reportj.KPI
          self.Tkpi = self.reportj.KPI
          self.currenttoggle = self.reportj.KPI
          self.versions = self.reportj.versions
          if (self.versions[0].version_status !== 'completed') {
            self.modelVesrionSelect = 1
          } else if (self.versions[0].version_status === 'completed') {
            self.modelVesrionSelect = 0
          }
          self.currencySymbol = self.reportj.currency_symbol
          if (self.reportj.KPI === ' ' || self.reportj.KPI === undefined) {
            self.kpi = 'Sales'
            self.Tkpi = 'Sales'
          }
          if (self.reportj.compare !== undefined) {
            self.enableCompare = true
          } else if (self.reportj.compare === undefined) {
            self.enableCompare = false
          }
          if (self.enableCompare === true) {
            // do something
            self.CompareTotalSpent = self.reportj.compare.AnnualSpend.per
            self.CompareEcosystemSales = self.reportj.compare.EcosystemSales.per
            self.CompareTotalSales = self.reportj.compare.TotalSales.per
            self.CompareMediaDrivenSales = self.reportj.compare.MediaDrivenSales.per
            self.CompareTotalSpentArrow = self.reportj.compare.AnnualSpend.effect
            self.CompareEcosystemSalesArrow = self.reportj.compare.EcosystemSales.effect
            self.CompareTotalSalesArrow = self.reportj.compare.TotalSales.effect
            self.CompareMediaDrivenSalesArrow = self.reportj.compare.MediaDrivenSales.effect
            $('.highlitboxes span').css({ 'top': '-17px' })
            $('.highlitboxes label').css({ 'display': 'block' })
          } else if (self.enableCompare === false) {
            $('.highlitboxes span').css({ 'top': '-25px' })
            $('.highlitboxes label').css({ 'display': 'none' })
          }
          // console.log(JSON.stringify(self.reportj.AnnualSpend))
          // self.TotalSpentarr = self.TotalSpentarr.push(self.reportj.AnnualSpend)
          var result = Object.keys(self.reportj.AnnualSpend).map(function (key, index) {
            self.sliderLength = index
            return [self.reportj.AnnualSpend[key]]
          })
          // console.log(result)
          self.reportj.edges.forEach(function (value, index) {
            // let res = self.reportj.edges[index].value.title.split('%')// self.reportj.edges[index].value = Math.floor(self.reportj.edges[index].value)
            // console.log(value)
          })
          self.reportj.nodes.forEach(function (value, index) {
            if (value.id <= 99 && value.id > 0) {
              self.reportj.edges.forEach(function (evalue, eindex) {
                if (value.id === evalue.from) {
                  if (evalue.from < 99 && evalue.to === 0) {
                    self.nodes.push(value)
                    nodes.add(value)
                    // window.network.body.data.nodes._updateItem(value)
                  }
                }
              })
              // self.nodes.push(value)
              // nodes.add(value)
            } else if (value.id === 0) {
              self.nodes.push(value)
              nodes.add(value)
            } else {
              self.addnodes.push(value)
            }
          })
          self.reportj.edges.forEach(function (value, index) {
            if (value.to === 0) {
              self.edges.push(value)
              edges.add(value)
            } else {
              self.addedges.push(value)
            }
          })
          self.TotalSpentarr = result
          self.hotSettings.colHeaders = ['', self.reportj.asymptote_values[self.kpi].nest_name + ' %']
          self.currentNest = self.reportj.asymptote_values[self.kpi]
          self.currentnest_name = self.reportj.asymptote_values[self.kpi].nest_name
          self.hotSettings.data = self.reportj.asymptote_values[self.kpi].channel
          self.calculatetotalspent(result)
          // data[0]['name'] = [].concat(...mydata)
          if (data.length === 0) {
            // self.displaypopup()
            return
          }
          self.cexcelHeight()
        } catch (err) {
          console.log(err)
          $('.spinner').hide()
          self.errorPopup()
        }
        return data
        // self.displaypopup()
      },
      error: function (data, error) {
        // console.log(data)
        console.log(error)
        $('.spinner').hide()
        self.errorPopup()
      }
    })
    var nodes = new vis.DataSet(this.nodes)
    var edges = new vis.DataSet(this.edges)
    this.container = document.getElementById('mynetwork')
    var data = {
      nodes: nodes,
      edges: edges
    }
    window.network = new vis.Network(this.container, data, this.options)
    var changeCursor = function (newCursorStyle) {
      var networkCanvas = document.getElementById('mynetwork').getElementsByTagName('canvas')[0]
      networkCanvas.style.cursor = newCursorStyle
    }
    var clusterOptionsByData = {
      joinCondition: function (nodeOptions) {
        return nodeOptions.cid === '2'
      },
      clusterNodeProperties: { id: 2, borderWidth: 3, shape: 'dot', font: { size: 30 }, allowSingleNodeCluster: true }
    }
    //
    window.network.cluster(clusterOptionsByData)

    window.network.on('doubleClick', function (params) {
      params.event = '[original event]'
      if (this.getNodeAt(params.pointer.DOM) === undefined) {
        return false
      }
      var nodesDataset = new vis.DataSet(self.nodes)
      var currentNodeLabel = nodesDataset.get(params.nodes)[0].id
      self.updateHotSetting(params, nodesDataset)
      if (currentNodeLabel === 0 || this.getNodeAt(params.pointer.DOM) === undefined) {
        return false
      }
      self.handleNetworkClickEvent(edges, nodes, currentNodeLabel)
    })
    window.network.on('hoverEdge', function (params, event) {
      params.event = '[original event]'
      var currentEdgeValue = this.body.data.edges.get(params.edge).title
      self.handleHoverEdgeEvent(params, currentEdgeValue)
      // return
    })
    window.network.on('blurEdge', function (params, event) {
      params.event = '[original event]'
      self.handleNodeEdgeBlurEvent()
    })
    window.network.on('hoverNode', function (params, event) {
      params.event = '[original event]'
      changeCursor('pointer')
      var currentEdgeValue = this.body.data.nodes.get(params.node).value
      var currentnodename = this.body.data.nodes.get(params.node).label
      self.handleHoverNodeEvent(params, currentEdgeValue, currentnodename)
      return
    })
    window.network.on('blurNode', function (params, event) {
      params.event = '[original event]'
      self.handleNodeEdgeBlurEvent()
    })
  }
}

</script>

<style lang='scss'>
.reportbutton {
  display: inline-block;
  padding: 0 15px;
  background: #000;
  border-radius: 6px;
  color: #fff;
  font-weight: bold;
  font-size: 15px;
  line-height: 40px;
  width: 120px;
  margin-right: 15px;
}
#mynetwork {
  width: 80%;
  height: 600px;
  border: 0px solid lightgray;
}

.slidertop {
  border: 1px solid #444;
  // width: 53%;
  // margin: 0 20px 40px 60px;
  background-color: #fac600;
  // float: left;
  margin-bottom: 55px;
}
.slider-wrapper {
  margin: 10px;
  width: 100%;
  position: relative;
  float: left;

  .vue-slider-component {
    padding: 0px !important;
    top: 41%;
    position: absolute;
    left: 25%;
  }
  label {
    width: 20%;
    line-height: 33px;
    position: relative;
    top: 3px;
    font-size: 16px;
    white-space: nowrap;
  }
  .slider-tooltip {
    font-size: 12px;
  }
  .slider-text {
    input {
      font-size: 16px;
      padding: 5px;
      position: absolute;
      top: 25px;
      right: 0;
      width: 90px;
      background-color: #9c9ca0;
      border: none;
      font-weight: bold;
      text-align: center;
    }
    input:active,
    input:focus {
      background-color: #000;
      color: #fff;
      border: none;
      box-shadow: none;
    }
    font-size: 12px;
    padding: 5px 2px;
    position: absolute;
    top: -50%;
    right: 6%;
    width: 50px;
  }
}
.slider-wrapper::after,
.slider-wrapper::before,
.slidertop::after,
.slidertop::before {
  content: '';
  clear: both;
  display: block;
}
.vue-slider-dot {
  background-color: #cf3f27 !important;
}

.highlitboxes {
  position: relative;
  color: #fff;
  text-align: center;
  margin-left: 8.33%;
  width: 12.1%;
  float: left;
  background: #000;
  min-width: 140px;
  z-index: 999;
  max-height: 60px;
}
.highlitboxes:first-child {
  margin-left: 70px;
}
.highlitboxes b {
  background: #d8d8d8;
  display: block;
  color: #000;
}

.highlitboxes span {
  display: inline-block;
  height: 100px;
  width: 100px;
  position: absolute;
  background: #f7891a;
  left: -88px;
  border-radius: 50px;
  top: -25px;
}
.highlitboxes span i {
  background: #f7891a url('../../../static/img/carticon.svg') no-repeat;
  display: inline-block;
  height: 50px;
  width: 50px;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  position: absolute;
}
.highlitboxes label {
  display: none;
  background: #f7f8f8;
  color: #444;
}
.highlitboxes.basesales span i {
  background: #f7891a url('../../../static/img/basesales.svg') no-repeat;
}
.salesblock {
  margin: 50px 40px 30px 60px;
}
.excelwrapper {
  float: left;
  padding-left: 20px;
  border-left: 1px solid lightgray;
}
.reportbuttonwrapper {
  float: left;
  text-align: left;
  padding: 30px;
}

.reportbuttonwrapper button {
  min-width: 97px;
  max-width: 20%;
  margin-right: 10px;
}
.chartarea {
  border-bottom: 1px solid lightgray;
  margin-bottom: 30px;
  margin: 0 30px 30px;
}
.exceltablestyle .htDimmed {
  background-color: #000 !important;
  color: #989595 !important;
  font-weight: bold;
}
.exceltablestyle th {
  background-color: #000 !important;
  color: #fff !important;
  font-weight: bold !important;
}
td.esheetclass {
  background: #fac600 !important;
}
.handsontable thead th.ht__highlight {
  background-color: #000 !important;
  text-align: center !important;
}
.handsontable thead th {
  background-color: #000 !important;
  text-align: center !important;
}
.handsontable td.esheetclass.htDimmed {
  text-align: left;
}

.handsontable tr td.esheetclass:last-child {
  text-align: center !important;
}
.report-anualspent {
  float: left;
  width: 50%;
  margin-left: 60px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}

.report-max-uplift {
  float: left;
  margin-left: 94px;
  margin-bottom: 20px;
  font-size: 16px;
  font-weight: bold;
}
button {
  border: none;
  outline: none;
}
.helpertable tr td:first-child,
.helpertable tr td.heading {
  background-color: #000;
  color: #fff;
  border-bottom: 1px solid #fff;
}

.helpertable {
  margin-left: 50px;
  float: left;
  /* border: 1px solid #000; */
  position: absolute;
  right: 60px;
  top: 462px;
  width: 200px;
  z-index: 9999;
}

.helpertable tr td,
.helpertable tr td.heading {
  padding: 5px;
  font-size: 16px;
  border: 1px solid #000;
  background-color: #fac600;
  font-weight: bold;
}
.helpertable tr td.heading {
  color: #000;
}

.helpertable tr:last-child td:first-child {
  border: 1px solid #000;
}
.helpertable tr:nth-child(3) td:first-child {
  border-bottom: 0px;
}
.tooltip2 {
  background-color: rgba(255, 255, 255, 0.59);
  display: inline-block;
  position: absolute;
  left: 100px;
  top: 500px;
  /* width: auto; */
  height: auto;
  line-height: 30px;
  padding: 0 5px;
  z-index: 99991;
  opacity: 1;
  font-size: 14px;
  font-weight: bold;
  color: #000;
  border: 1px solid #000;
  /* vertical-align: middle; */
  text-align: center;
  opacity: 0;
  transition: background 0.5s linear;
}
.emptyCells {
  background: #cf3f27 !important;
}
.leftside {
  float: left;
  width: 53%;
  margin: 0 20px 40px 60px;
  position: relative;
}
.optimiseBtn {
  background-color: #fac600;
  color: #000;
  position: relative;
  z-index: 99999;
}
.resetreportBtn {
  background-color: #dc3f34;
  color: #fff;
  position: relative;
  z-index: 99999;
}
.optimiseBtn.disabled {
  background-color: rgb(216, 216, 216);
}
.inputOptimizeNamr.view .optiarrow,
.inputOptimizeNamr.view a.verclosebutton,
.inputOptimizeNamr.view input,
.inputOptimizeNamr.view button.optimiseBtnGO {
  display: none;
}

.graydot {
  background-color: #000 !important;
}
</style>
<style >
</style>
<style >
.togglebutton {
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f1b828;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.switch input.checked + .slider {
  background-color: #f7891a;
}

input:focus + .slider {
  box-shadow: 0 0 1px #f1b828;
}

inp ut:checked + .slider:before,
.switch input.checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

span.selcteditem {
  display: inline-block;
  line-height: 34px;
  position: relative;
  float: left;
  font-size: 16px;
  font-weight: bold;
  margin-left: 10px;
  width: 50px;
}

.togglebutton {
  position: absolute;
  right: 69px;
}
.togglebutton .switch {
  float: left;
}
.togglerBoxes {
  transition: transform 0.6s;
  transform-style: preserve-3d;
}
.togglerBoxes.active {
  transform: rotateX(360deg);
}
.togglerBoxes .MediaDrivenROI,
.togglerBoxes .EcosystemROI,
.togglerBoxes.active .MediaDrivenSales,
.togglerBoxes.active .EcosystemSales {
  display: block;
}
.togglerBoxes.active .MediaDrivenROI,
.togglerBoxes.active .EcosystemROI,
.togglerBoxes .MediaDrivenSales,
.togglerBoxes .EcosystemSales {
  display: none;
}
.highlitboxes.togglerBoxes span i,
.highlitboxes.togglerBoxes span {
  background-color: #f1b828;
}
.highlitboxes.togglerBoxes.active span i,
.highlitboxes.togglerBoxes.active span {
  background-color: #f7891a;
}

.optimiseWidgetWrapper {
  position: absolute;
  z-index: 99;
  top: -52px;
  right: -13px;
}

.inputOptimizeNamr {
  position: absolute;
  width: 350px;
  max-width: 500px;
  top: -85px;
  right: 0px;
  border: 1px solid #232323;
  padding: 20px;
  background: RGBA(255, 255, 255, 0.9);
  transition: all 0.5s linear;
  height: 76px;
  z-index: 9999;
  /* bottom: 0px; */
}
.inputOptimizeNamr input,
.inputOptimizeNamr button {
  transition: all 2s linear;
}
.inputOptimizeNamr.view input,
.inputOptimizeNamr.view button {
  opacity: 0;
  transition: all 2s linear;
}
.inputOptimizeNamr.view {
  transition: all 0.5s linear;
  background: RGBA(255, 255, 255, 0);
  /* left: -232%; */
  z-index: 0;
  position: absolute;
  /* left: -10%; */
  height: 0px;
  padding: 0px;
  /* border: 0px; */
  opacity: 0;
  top: 0;
  /* display: none; */
  width: 0;
}
.inputOptimizeNamr.view a.verclosebutton {
  display: none;
}
.inputOptimizeNamr input {
  width: 80%;
}
.inputOptimizeNamr input.error {
  border: 1px solid red;
}
.error-msg {
  color: red;
}
.inputOptimizeNamr .input-box {
  position: relative;
}

button.optimiseBtnGO {
  position: absolute;
  top: -3px;
  right: 0;
  width: auto;
}
.optiarrow {
  font-size: 30px;
  position: absolute;
  bottom: -20px;
  right: 62px;
}
a.verclosebutton {
  position: absolute;
  z-index: 999;
  top: -10px;
  right: -10px;
  font-size: 14px;
  color: #fff;
  background-color: #000;
  border-radius: 30px;
  padding: 0 6px;
  line-height: 23px;
  cursor: pointer;
}
.handsontableReport .wtHider {
  height: 200px !important;
}
.reportpageexcelwrapper,
.leftside {
  min-height: 200px;
}

.reportpageexcelwrapper .handsontableReport {
  overflow-y: auto !important;
}
.reportpageexcelwrapper .handsontable .wtHider,
.reportpageexcelwrapper .ht_master .wtHolder {
  height: auto !important;
}
.highlitboxes label i {
  margin-left: 4px;
  font-size: 18px;
  line-height: 20px;
}
</style>



// WEBPACK FOOTER //
// Report.vue?19e5b990